import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import { ReactElement } from 'react';
import InboxIcon from '@mui/icons-material/Inbox';
import { ReactComponent as TableIcon } from 'assets/icons/table.icon.svg';
import ChatIcon from '@mui/icons-material/Chat';
import FolderIcon from '@mui/icons-material/Folder';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PeopleIcon from '@mui/icons-material/People';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ViewListIcon from '@mui/icons-material/ViewList';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import CloudIcon from '@mui/icons-material/Cloud';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

export const SidebarMenuItemIconMap: Record<string, ReactElement> = {
  ['Dashboards']: <SpaceDashboardIcon />,
  ['Products']: <InboxIcon />,
  ['Customer data']: <PeopleIcon />,
  ['Chatbot Flows']: <ChatIcon />,
  ['Customer files']: <FolderIcon />,
  ['Customer servicing']: <TableIcon />,
  ['Required Documents']: <UploadFileIcon />,
  ['Access Management']: <AdminPanelSettingsIcon />,
  ['Mini CRM']: <TableIcon />,
  ['Mini CRM Table']: <ArticleOutlinedIcon />,
  ['Dashboard']: <SpaceDashboardIcon />,
  ['Audit Logs']: <ViewListIcon />,
  ['Home']: <SpaceDashboardIcon />,
  ['Applications']: <PeopleIcon />,
  ['Reports']: <ContentPasteIcon />,
  ['Activity']: <ViewHeadlineIcon />,
  ['API Documentation']: <CloudIcon />,
  ['Jira Management']: <SettingsIcon />,
  ['Partners']: <BusinessCenterIcon />,
};
